import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from './navbar/navbar.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { QRCodeModule } from 'angularx-qrcode';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { NgxTinymceModule } from 'ngx-tinymce';
import { DeleteConfrimModalComponent } from './delete-confrim-modal/delete-confrim-modal.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProgressStepsComponent } from './progress-steps/progress-steps.component';
import { CardWithTabsComponent } from './card-with-tabs/card-with-tabs.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DocumentUploadModalComponent } from './document-upload-modal/document-upload-modal.component';
import { PositionsCreateEditComponent } from './settings/positions-create-edit/positions-create-edit.component';
import { DescriptionCreateEditComponent } from './settings/description-create-edit/description-create-edit.component';
import { LawyerLevelCreateEditComponent } from './settings/lawyer-level-create-edit/lawyer-level-create-edit.component';
import { MarineContactCreateEditComponent } from './settings/marine-contact-create-edit/marine-contact-create-edit.component';
import { ServicesCreateEditComponent } from './settings/services-create-edit/services-create-edit.component';
import { ShipsCreateEditComponent } from './settings/ships-create-edit/ships-create-edit.component';
import { ProtectionClubCreateEditComponent } from './settings/protection-club-create-edit/protection-club-create-edit.component';
import { OwnerCreateEditComponent } from './settings/owner-create-edit/owner-create-edit.component';
import { CharterCreateEditComponent } from './settings/charter-create-edit/charter-create-edit.component';
import { RepresentativeCreateEditComponent } from './settings/representative-create-edit/representative-create-edit.component';
import { CourtCreateEditComponent } from './settings/court-create-edit/court-create-edit.component';
import { CircleCreateEditComponent } from './settings/circle-create-edit/circle-create-edit.component';
import { ClaimTypeCreateEditComponent } from './settings/claim-type-create-edit/claim-type-create-edit.component';
import { OpponentCreateEditComponent } from './settings/opponent-create-edit/opponent-create-edit.component';
import { FilterPipe } from './pipes/search/filter.pipe';
import { LawyerCreateEditComponent } from './settings/lawyer-create-edit/lawyer-create-edit.component';
import { DepartmentCreateEditComponent } from './settings/department-create-edit/department-create-edit.component';
import { ExpertCreateEditComponent } from './settings/expert-create-edit/expert-create-edit.component';
import { UserCreateEditComponent } from './settings/user-create-edit/user-create-edit.component';
import { EmailConfirmDirective } from './directives/email-confirm.directive';
import { TimesheetEntryFormComponent } from './timesheet/timesheet-entry-form/timesheet-entry-form.component';
import { SessionNoteCreateEditComponent } from './settings/session-note-create-edit/session-note-create-edit.component';
import { CaseSubjectCreateEditComponent } from './settings/case-subject-create-edit/case-subject-create-edit.component';
import { CasePostponeCreateEditComponent } from './settings/case-postpone-create-edit/case-postpone-create-edit.component';
import { NgxMaskModule } from 'ngx-mask';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { PasswordConfirmDirective } from './directives/password-confirm.directive';
import { FileSummaryModalComponent } from './file-summary-modal/file-summary-modal.component';
import { RejectRequestModalComponent } from './reject-request-modal/reject-request-modal.component';
import { ClientSummaryModalComponent } from './client-summary-modal/client-summary-modal.component';
import { ClosingRemarksModalComponent } from './closing-remarks-modal/closing-remarks-modal.component';
import { SharedFileSummaryComponent } from './file-summary/file-summary.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FileExpenseFormComponent } from './file-expense-form/file-expense-form.component';
import { FilesFilterComponent } from './files-filter/files-filter.component';
import { CreateNewClaimComponent } from './create-new-claim/create-new-claim.component';
import { TimesheetEntryModalComponent } from './timesheet/timesheet-entry-modal/timesheet-entry-modal.component';
import { CreateEditFileClientComponent } from './create-edit-file-client/create-edit-file-client.component';
import { CreateEditCaseOpponentComponent } from './create-edit-opponent/create-edit-opponent.component';
import { CaseLawyerHistoryComponent } from './case-lawyer-history/case-lawyer-history.component';
import { CaseHearingRowDetailsComponent } from './case-hearing-row-details/case-hearing-row-details.component';
import { CaseContactComponent } from './case-contact/case-contact.component';
import { CityCreateEditComponent } from './settings/city-create-edit/city-create-edit.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';


@NgModule({
  declarations: [
    NavbarComponent,
    AdminLayoutComponent,
    SidebarComponent,
    LoginFormComponent,
    TextEditorComponent,
    DeleteConfrimModalComponent,
    SafeHtmlPipe,
    ProgressStepsComponent,
    CardWithTabsComponent,
    DocumentUploadModalComponent,
    CaseSubjectCreateEditComponent,
    DescriptionCreateEditComponent,
    LawyerLevelCreateEditComponent,
    MarineContactCreateEditComponent,
    PositionsCreateEditComponent,
    ServicesCreateEditComponent,
    ShipsCreateEditComponent,
    ProtectionClubCreateEditComponent,
    OwnerCreateEditComponent,
    CharterCreateEditComponent,
    RepresentativeCreateEditComponent,
    CourtCreateEditComponent,
    CircleCreateEditComponent,
    CasePostponeCreateEditComponent,
    ClaimTypeCreateEditComponent,
    OpponentCreateEditComponent,
    FilterPipe,
    LawyerCreateEditComponent,
    DepartmentCreateEditComponent,
    ExpertCreateEditComponent,
    UserCreateEditComponent,
    EmailConfirmDirective,
    TimesheetEntryFormComponent,
    SessionNoteCreateEditComponent,
    ConfirmModalComponent,
    PasswordConfirmDirective,
    FileSummaryModalComponent,
    RejectRequestModalComponent,
    ClientSummaryModalComponent,
    ClosingRemarksModalComponent,
    SharedFileSummaryComponent,
    FileExpenseFormComponent,
    FilesFilterComponent,
    CreateNewClaimComponent,
    TimesheetEntryModalComponent,
    CreateEditFileClientComponent,
    CreateEditCaseOpponentComponent,
    CaseLawyerHistoryComponent,
    CaseHearingRowDetailsComponent,
    CaseContactComponent,
    CityCreateEditComponent,
    ResetPasswordFormComponent,
  ],
  imports: [
    NgxMaskModule.forRoot(),
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    SelectDropDownModule,
    NgxDropzoneModule,
    QRCodeModule,
    NgxTinymceModule.forRoot({ baseURL: '//cdnjs.cloudflare.com/ajax/libs/tinymce/5.3.2/' }),
    UiSwitchModule.forRoot({
      color: '#777777',
      switchColor: '#fff',
      defaultBgColor: '#777777',
      checkedTextColor: '#fff',
      uncheckedTextColor: '#fff',
    }),
    NgSelectModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    ReactiveFormsModule,
  ],
  exports: [
    NgbModule,
    NavbarComponent,
    AdminLayoutComponent,
    SidebarComponent,
    LoginFormComponent,
    SelectDropDownModule,
    QRCodeModule,
    TextEditorComponent,
    DeleteConfrimModalComponent,
    UiSwitchModule,
    SafeHtmlPipe,
    NgSelectModule,
    ProgressStepsComponent,
    CardWithTabsComponent,
    NgxDatatableModule,
    CalendarModule,
    DocumentUploadModalComponent,
    ReactiveFormsModule,
    PositionsCreateEditComponent,
    CaseSubjectCreateEditComponent,
    DescriptionCreateEditComponent,
    LawyerLevelCreateEditComponent,
    MarineContactCreateEditComponent,
    PositionsCreateEditComponent,
    ServicesCreateEditComponent,
    ShipsCreateEditComponent,
    ProtectionClubCreateEditComponent,
    OwnerCreateEditComponent,
    CharterCreateEditComponent,
    RepresentativeCreateEditComponent,
    CourtCreateEditComponent,
    CircleCreateEditComponent,
    CasePostponeCreateEditComponent,
    ClaimTypeCreateEditComponent,
    OpponentCreateEditComponent,
    FilterPipe,
    LawyerCreateEditComponent,
    DepartmentCreateEditComponent,
    ExpertCreateEditComponent,
    UserCreateEditComponent,
    TimesheetEntryFormComponent,
    SessionNoteCreateEditComponent,
    ConfirmModalComponent,
    EmailConfirmDirective,
    PasswordConfirmDirective,
    FileSummaryModalComponent,
    RejectRequestModalComponent,
    ClientSummaryModalComponent,
    ClosingRemarksModalComponent,
    SharedFileSummaryComponent,
    FileExpenseFormComponent,
    FilesFilterComponent,
    TimesheetEntryModalComponent,
    CaseLawyerHistoryComponent,
    CaseHearingRowDetailsComponent,
    CityCreateEditComponent,
    ResetPasswordFormComponent
  ]
})
export class SharedModule { }
